export default __webpack_public_path__ + "static/media/locations_information.d1756be8.csv";